import { loadModal } from '../../../AsyncLoader';
import ContentStorage, { ComponentKeys } from '../../../tnew/content/ContentStorage';

const { formButtonHandler } = window.tnew.handlers;


function getModalProperties() {
  const key = ComponentKeys.PACKAGES;

  return {
    title: ContentStorage.get(key, 'ExpiredFlexSessionErrorMessageSubhead'),
    closeButtonLabel: ContentStorage.get(key, 'ExpiredFlexSessionErrorMessageCloseButtonLabel'),
  };
}


const showModal = async ({ url, message }) => {
  const Modal = await loadModal();

  const modalProperties = getModalProperties();

  const $btn = Modal.utils.makePrimaryButton(modalProperties.closeButtonLabel);

  $btn.on('click', () => {
    formButtonHandler.applyBusyStyling($btn);

    setTimeout(() => {
      window.location.href = url;
    }, 100);
  });

  Modal.open({
    title: modalProperties.title,
    bodyContents: message,
    footerContents: $btn,
    closeOnEscape: false,
    closeOnBackdrop: false,
    closeButtonInHeader: false,
  });
};


function checkForInvalidFlexSessionResponse(response) {
  return new Promise((resolve) => {
    if (response.status === 'InvalidFlexSession') {
      showModal(response);

      return;
    }

    resolve(response);
  });
}


export default {
  checkForInvalidFlexSessionResponse,
};
